import { Button } from "@chakra-ui/react";
import useWorkerStressTest from "./useWorkerStressTest";
const Teste = () => {
  const { ativar } = useWorkerStressTest();
  return (
    <div className="max-w-screen-xl mx-auto ">
      <div className="my-8 flex gap-2 flex-wrap">
        <h2 className="font-bold text-2xl w-full my-4">Notificações</h2>
        <Button
          className="button"
          type="Button"
          onClick={() => { ativar() }}
        >
          Testar
        </Button>
      </div>
    </div>
  );
};

export default Teste;
